module.exports = {"654024100":"巩留镇","654024101":"阿克吐别克镇","654024102":"库尔德宁镇","654024103":"东买里镇","654024104":"阿尕尔森镇","654024105":"提克阿热克镇","654024201":"吉尔格郎乡","654024204":"塔斯托别乡","654024400":"综合农场","654024401":"阔什阿尕什羊场","654024402":"牛场","654024403":"良凡场","654024405":"林场","654024406":"莫乎尔农场","654024510":"兵团七十三团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654024.json
// module id = 3131
// module chunks = 0